import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import {
  LucideAngularModule,
  XIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from 'lucide-angular';

@Component({
  selector: 'allas-sidebar',

  imports: [CommonModule, LucideAngularModule],
  templateUrl: 'sidebar.html',
})
export class SidebarComponent {
  @Output() closeSidebar = new EventEmitter<void>();

  readonly xIcon = XIcon;
  readonly chevronDownIcon = ChevronDownIcon;
  readonly chevronRightIcon = ChevronRightIcon;

  expandedSections: string[] = [];

  toggleSection(sectionId: string): void {
    this.expandedSections = this.expandedSections.includes(sectionId)
      ? this.expandedSections.filter((id) => id !== sectionId)
      : [...this.expandedSections, sectionId];
  }

  onSidebarLinkClick(): void {
    this.closeSidebar.emit();
  }

  isSectionExpanded(sectionId: string): boolean {
    return this.expandedSections.includes(sectionId);
  }

  // ESTRUCTURA PRINCIPAL DEL SIDEBAR BASADA EN LAS RUTAS Y FOOTER

  // 3. COMPRAR POR
  shopBy = [
    { name: 'Comprar por Marca', href: '/comprar/marca' },
    { name: 'Comprar por Modelo', href: '/comprar/modelo' },
    {
      name: 'Comprar por Marca de Producto',
      href: '/comprar/marca-producto',
    },
    { name: 'Catálogo o Categorías', href: '/repuestos' },
  ];

  // 4. SERVICIOS
  services = [
    {
      name: 'Servicios',
      href: '/servicios',
      subcategories: [
        {
          name: 'Diagnóstico e Instalación de Baterías',
          href: '/servicios/diagnostico-instalacion-baterias',
        },
        {
          name: 'Instalación de Filtros',
          href: '/servicios/instalacion-filtros',
        },
        { name: 'Entrega a Domicilio', href: '/servicios/entrega-domicilio' },
        {
          name: 'Cambio de Limpiaparabrisas',
          href: '/servicios/cambiar-limpiaparabrisas',
        },
        {
          name: 'Reciclaje de Baterías',
          href: '/servicios/reciclaje-baterias',
        },
        {
          name: 'Cotización por WhatsApp',
          href: '/servicios/cotiza-por-whatsapp',
        },
        { name: 'Talleres Referidos', href: '/servicios/talleres-referidos' },
        { name: 'Programa de Afiliados', href: '/servicios/afiliaciones' },
      ],
    },
  ];
}
